import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

const SocialMedia = (props) => {
  const { serviceProductForm } = props

  const {
    entityState: {
      options: { social_media },
    },
    handlers,
  } = serviceProductForm

  const { buildable, templatable } = social_media

  return (
    <DashboardModule title="Social Media">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Built on Realhub">
            <select
              data-value-type="boolean"
              name="options.social_media.buildable"
              value={buildable}
              {...handlers}
            >
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>

          <Form.Field label="Templatable" marginTop={['large', 0]}>
            <select
              data-value-type="boolean"
              name="options.social_media.templatable"
              value={templatable}
              {...handlers}
            >
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

SocialMedia.propTypes = {
  serviceProductForm: PropTypes.object,
}

export default SocialMedia
